var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBrokenPenTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.37 4.41c-.47-.47-.47-1.23 0-1.7l.78-.78c.47-.47 1.23-.47 1.7 0l.78.78c.47.47.47 1.23 0 1.7l-.78.78c-.47.47-1.23.47-1.7 0l-.78-.78zM20.55 9.81c.66 0 1.2.54 1.2 1.2v1.1c0 .66-.54 1.2-1.2 1.2h-1.1c-.66 0-1.2-.54-1.2-1.2v-1.1c0-.66.54-1.2 1.2-1.2h1.1zM3.45 9.81c-.66 0-1.2.54-1.2 1.2v1.1c0 .66.54 1.2 1.2 1.2h1.1c.66 0 1.2-.54 1.2-1.2v-1.1c0-.66-.54-1.2-1.2-1.2h-1.1zM18.54 10.1l-5.3-5.3M5.461 10.1l2.65-2.65M13.271 22.5c.96 0 1.58-.68 1.4-1.51l-.41-1.81h-4.5l-.41 1.81c-.18.78.5 1.51 1.4 1.51h2.52zM14.22 12.67l-1.05-1.33c-.64-.81-1.69-.81-2.33 0l-3.05 3.87c-.77.97-.77 1.6.24 2.43l1.73 1.54M14.262 19.17l1.73-1.54c.97-.86 1.01-1.46.24-2.43M12.011 11.12v2.53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBrokenPenTool);
export default __webpack_public_path__ + "static/media/vuesax-broken-pen-tool.2e90daf7b2d4f27bc6e10e5ea5a9f11f.svg";
export { ForwardRef as ReactComponent };